import React from 'react';
import styles from '@/styles/PageHeading.module.scss';

type props = {
  title?: string;
  subTitle?: string;
};

export const PageHeading = ({ title, subTitle = 'News, insights, analysis and data' }: props) => {
  return (
    <div className={styles.container}>
      <h1 className={styles['page-title']} data-test-id='header-title-id'>
        {title}
      </h1>
      <p className={styles['page-sub-title']}>{subTitle}</p>
    </div>
  );
};
